import React, {Component} from 'react';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import {Grid, Popper, Typography} from '@material-ui/core';
import {TextField} from '@material-ui/core';
import instance from '../../request/http';
import {BASE_URL} from '../../store/config';
import Autocomplete from '@material-ui/lab/Autocomplete';
import debounce from 'lodash/debounce';


/*
This component supports user autocomplete selector
props:
initUser: {id, email, last_name, first_name} NOTE: null will show current user
update: callback, used to update father's user value
 */

class UserAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.initUser = null;

        if (this.props.initUser !== null) {
            this.initUser = this.props.initUser;
        }

        this.state = {
            user: this.initUser,
            userOptions: [],
        };

        console.log("INIT>>>>>>>>>>.");

        // set current user as default
        this.props.update(this.initUser);

        // value changing may invoke change and inputChange at the same time.
        // This variable is used to block some useless inputChange events
        this.block = false;

        this.handleFocusout = this.handleFocusout.bind(this);
        this.handleAutoChange = this.handleAutoChange.bind(this);
        this.handleAutoInputChange = this.handleAutoInputChange.bind(this);
        this.handleAutoInputThrottled = debounce(this.handleAutoInputChange, 200);
    }

    render() {
        const {
            user,
            userOptions,
        } = this.state;

        // console.log(userOptions);

        const acPopper = function (props) {
            return (<Popper {...props} style={{width: 'auto', minWidth: '300px'}} placement='bottom-start'/>)
        };

        return (
            <Autocomplete
                style={{margin: 0, width: '100%', backgroundColor: '#fff'}}
                value={user}
                disabled={this.props.disabled}
                onChange={this.handleAutoChange}
                onBlur={this.handleFocusout}
                onInputChange={this.handleAutoInputThrottled}
                options={userOptions}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.first_name + ' ' + option.last_name}
                filterOptions={(x) => x}
                PopperComponent={acPopper}
                renderInput={(params) => (
                    <TextField {...params} label="Search users" margin="dense" variant="outlined" fullWidth/>
                )}
                renderOption={(option) => {
                    return (
                        <Grid container alignItems="center">
                            <Grid item style={{marginRight: 10}}>
                                <AccountBoxIcon/>
                            </Grid>
                            <Grid item xs>
                                {option.first_name + ' ' + option.last_name}
                                <Typography variant="body2" color="textSecondary">
                                    {option.email}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        );
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }


    // block request after the focusout event
    handleFocusout() {
        this.block = true;
        this.setState(() => ({
            userOptions: [],
        }));
    }

    handleAutoChange(e, value) {
        console.log("====选择===");
        console.log(value);

        // only happens when clearing all the inputs
        if (value === null) {
            return;
        }

        this.block = true;
        // update the father's value
        this.props.update(value);
        this.setState(() => ({
            user: value,
        }));
    }

    handleAutoInputChange(e, value) {
        console.log("====输入===");
        console.log(value);

        if (this.block) {
            this.block = false;
            return;
        }

        // simply clear the userOptions if the input is empty
        if (value === null || value === "") {
            this.setState(() => ({
                userOptions: [],
            }));
            return;
        }

        let params = {
            search_content: value
        };

        instance.get(BASE_URL + 'users/fuzzy_matching', {params}).then((res) => {
            const users = res.data.data;
            console.log(users);
            this.setState(() => ({
                userOptions: users,
            }));
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        });
    }

}

export default UserAutoComplete;